// TODO(SuperPaintman): Remove those rules later
/* tslint:disable:no-use-before-declare restrict-plus-operands cyclomatic-complexity deprecation max-classes-per-file max-line-length ter-max-len newline-before-return newline-per-chained-call prefer-template */

import React, {Component, ComponentClass, ComponentType} from 'react'
import EventEmitter from 'events'
import url from 'url'
import path from 'path'
import {wrapDisplayName, compose, mapProps, hoistStatics, getContext} from 'recompose'
import {matchPath, match as originalMatch, RouteProps as OriginalRouteProps} from 'react-router'
import {Link as OriginalLink, LinkProps as OriginalLinkProps} from 'react-router-dom'
import Context from '@eda.yandex/ui-kit/config/constants/context'
import {Location, History, LocationDescriptor} from 'history'
import humps from 'humps'
import PropTypes from 'prop-types'
import qs from 'query-string'
import {isEqual, merge, omit, pick} from 'lodash-es'
import {ApiError} from './lib/errors'
import hoistNonReactStatics from 'hoist-non-react-statics'

declare module 'history' {
  export interface History {
    /**
     * Replace location without calling `updateLocation()` and controller
     *
     * See: https://st.yandex-team.ru/EDADEV-7321#1536082461000
     */
    silentReplace (path: Path): void
    silentPush (path: Path): void
    tryGoBack (path: Path): void
  }
}

/**
 * Расширяем интерфейс location и добавляем туда params
 */
export type ILocation = Location & { params?: IMatchParams }
export type ViewConfig<Env, Params = IParams> = {
  displayName?: string
  controller?: IController<Env, Params>
  Component?: ComponentType
  loadComponent?(): Promise<ComponentType>
  ErrorComponent?: ErrorComponentType<Env>
  loadErrorComponent?(): Promise<ErrorComponentType<Env>>
  ChildErrorComponent?: ErrorComponentType<Env>
  loadChildErrorComponent?(): Promise<ErrorComponentType<Env>>
}

type IMatch = originalMatch<IMatchParams>
type IMatchParams = { [k: string]: string } | {}

export type IParams = { [k: string]: boolean | null | string | string[] }

/**
 * Структура для описания роута
 */
export type IRouteShape<Env> = {
  /**
   * Путь, для которого отрисовывем компонент
   */
  path: string
  /**
   * Конфиг с компонентом, который отрисовываем для этого роута. Может отсутствовать, если роут нужн для редиректа
   */
  viewConfig?: ViewConfig<Env, any>
  /**
   * Требуется ли точно совпадение с роутом. Если не указан, то false, если у роута есть дочерние роуты
   */
  exact?: boolean
  /**
   * Требуется ли точное совпадение с роутом со слешом/без слеша
   */
  strict?: boolean
  /**
   * Редирект на другую страницу
   */
  redirectTo?: string
  /**
   * Доп. параметры. Мержатся с параметрами GET-параметрами и роут-параметрами
   */
  params?: {
    [key: string]: any
  }
  /**
   * Дочерние роуты
   */
  routes?: Array<IRouteShape<Env>>
}

export enum ScrollBehavior {
  /**
   * Скролл будет наверху
   */
  Top,
  /**
   * Восстановится последнее значение скролла, которое было у данного контроллера
   */
  Restore,
  /**
   * Скролл останется в том же положении
   */
  Prevent
}

export type ControllerResult = {
  /**
   * Перейти на следующий роут
   */
  goNext?: boolean
  /**
   * Перенаправить на другую страницу
   */
  redirect?: {
    to: string
    withQueryParams?: boolean
  }
  /**
   * HTTP статус, с которым перенаправляем или возвращаем ошибку
   */
  httpStatus?: number
  /**
   * Ошибка
   */
  error?: RouteError
  /**
   * Поведение скролла при завершении работы контроллера
   * Если не указано, то при нажатии кнопки "назад" возвращаем положение скролла к предыдущему состоянию
   */
  scroll?: ScrollBehavior
}

/**
 * Контроллер для извлечения данных для конкретного роута
 */
export type IController<Env, Params> = {
  (
    route: RouteUnit<Env, Params>,
    env: Env,
    next?: () => Promise<ControllerResult | void>
  ): Promise<ControllerResult | void>
}

function enhanceLocationWithParams (location: ILocation): void {
  if (location.params) { return }
  if (!location.search) {
    location.params = {}
  } else {
    if (location.search.indexOf('?') === 0) {
      location.params = qs.parse(location.search.slice(1))
    } else {
      location.params = qs.parse(location.search)
    }
  }
}

export enum RouteNode { Self, Parent, Child, Ancestor, Descendant }

export function urlToLocation (u: string): ILocation {
  const {pathname = '', search = '', hash = ''} = url.parse(u)

  return {
    pathname,
    search,
    state: {},
    hash
  }
}

export type StateChain = Array<{path: string, displayName?: string, error?: RouteErrorJSON}>

type UpdateLocationResult = {
  /**
   * Путь на который нужно сделать редирект
   */
  redirectTo?: string
  /**
   * HTTP статус, который необходимо отправить на клиент
   */
  httpStatus?: number
  /**
   * Ошибка, которую так же нужно отправить на клиент
   */
  error?: RouteError
  /**
   * Состояние выбранных роутов, тоже нужно отправить на клиент
   */
  stateChain: StateChain
  /**
   * Состояние скролла
   */
  scroll?: ScrollBehavior
}

export type IUpdateLocationOptions = {
  // Maybe, we uncomment it in the future
  // /**
  //  * Происходит ли обновление роута на сервере
  //  */
  // serverSideRender?: boolean
  /**
   * Цепочка состояний для уже отрисованного роута
   */
  stateChain?: StateChain
  /**
   * Позиция скролла
   */
  scrollPosition?: number
}

// TODO(spereskokov) Добавить type-safe EventEmitter c типами для аргументов
export enum RouteManagerEvents {
  ControllersUpdated = 'ControllersUpdated',
  ComponentsUpdated = 'ComponentsUpdated'
}

type RouteErrorJSON = Pick<RouteError, 'status' | 'message' | 'data' | 'name' | 'stack'>

class RouteError {
  /**
   * HTTP статус ошибки
   */
  status?: number
  /**
   * Сообщение ошибки
   */
  message: string
  /**
   * Какие то кастомные данные ошибки
   */
  data?: any
  /**
   * Стек ошибки
   */
  stack: string
  /**
   * Название ошибки
   */
  name = 'RouteError'

  constructor (e: Error | ApiError | RouteErrorJSON) {
    this.status = e instanceof Error ? 500 : (e.status || 500)
    this.data = e instanceof Error ? null : e.data
    this.message = e.message || this.toString()
    this.stack = e instanceof Error ? (e.stack || '') : `Request failed with status: ${e.status!}`
  }

  toJSON (): RouteErrorJSON {
    return {
      status: this.status,
      message: this.message,
      data: this.data,
      name: this.name,
      stack: this.stack
    }
  }

  toString () {
    return JSON.stringify(this, null, 2)
  }
}

export type ErrorComponentProps<Env> = {
  error: RouteError
  routeUnit: RouteUnit<Env>
}

export type ErrorComponentType<Env> = ComponentType<ErrorComponentProps<Env>>

/**
 * Менеджер контроллеров
 * Хранит в себе данные о том:
 * - какие контроллеры сейчас извлекают данные
 * - какие контроллеры сейчас активны
 * - какие контроллеры будут активны на следующем шаге
 */
export class RouteManager<Env> {
  /**
   * Текущая цепочка роутов
   */
  rootRouteUnit: RouteUnit<Env> | null = null
  /**
   * Emitter
   */
  emitter = new EventEmitter()
  /**
   * Текущий location
   */
  location?: ILocation

  constructor (
    /**
     * Окружение, которое передается во все контроллеры
     */
    public env: Env,
    /**
     * Массив с роутами
     */
    readonly routes: Array<IRouteShape<Env>>,
    /**
     * История
     */
    public history: History,
    /**
     * Компонент ошибки по-умолчанию, который будет использован, если
     * `ErrorComponent` в компоненте страницы не определен.
     */
    public DefaultErrorComponent: ErrorComponentType<Env>,
    /**
     * Обработчик ошибок
     */
    public errorHandler: (e: Error) => void,
    /**
     * Базовый URL, относительно которого строятся другие URL
     * Используется для патчинга push/replace, формирования Link, обслуживания matchPath
     */
    readonly baseURL: string = '/'
  ) {}

  /**
   * Устанавливаем новый url
   * При установки, загружаются все необходимые данные для контроллеров
   */
  async updateLocation (location: ILocation, options: IUpdateLocationOptions = {}): Promise<UpdateLocationResult> {
    if (this.location === location || !this.routes.length) {
      return {stateChain: []}
    }
    // Нам мог прийти ещё один updateLocation, при этом текущий ещё не отработал, в таком случае игнорируем результат
    enhanceLocationWithParams(location)

    let rootRouteUnit: RouteUnit<Env> | null = null
    let parentRouteUnit: RouteUnit<Env> | null = null
    let queue: Array<IRouteShape<Env>> = []
    let relativeRouteUnit = this.rootRouteUnit
    let prefix = '/'
    let i = 0
    let j = 0
    let error: RouteError
    const stateChain = options.stateChain && options.stateChain.slice()

    // result имеет значение:
    // 1. при серверном рендренге
    // 2. при обновлении location в браузере (не при инициализационном рендеринге)
    const result: UpdateLocationResult = {
      stateChain: stateChain || []
    }

    do {
      if (!queue.length && i < this.routes.length) {
        queue.push(this.routes[i++])
      }
      const route = queue.shift()

      if (!route) {
        break
      }
      const purePath = route.path.split('?')[0]
      const routePath = purePath.indexOf('/') === 0 || purePath === '*' ? purePath : prefix + purePath
      const matchOptions = {
        path: routePath,
        strict: route.strict !== undefined ? route.strict : false,
        exact: route.exact !== undefined ? route.exact : !route.routes
      }
      const pathnameWithoutBaseURL = ('/' + location.pathname.substr(this.baseURL.length)).replace(/\/{2,}/g, '/')
      const match = matchPath(pathnameWithoutBaseURL, matchOptions)

      if (match) {
        if (route.redirectTo) {
          result.redirectTo = route.redirectTo
          break
        }

        // TODO(SuperPaintman): we declare type because we have a circular reference here
        const routeUnit: RouteUnit<Env> = new RouteUnit<Env>(route, match, location, this, parentRouteUnit || undefined)

        if (parentRouteUnit) {
          parentRouteUnit.child = routeUnit
          routeUnit.parent = parentRouteUnit
        }

        // // может быть кейс, когда при разных родительских компонентах будет один и тот же дочерний компонент
        if (relativeRouteUnit) {
          routeUnit.prev = relativeRouteUnit
          relativeRouteUnit.next = routeUnit
        }

        const {viewConfig} = routeUnit.routeShape

        if (stateChain) {
          const savedState = stateChain[j]

          if (!savedState) {
            break
          }

          if (viewConfig && savedState.displayName === viewConfig.displayName && route.path === savedState.path) {
            if (savedState.error) {
              routeUnit.error = new RouteError(savedState.error)
            }
            j++
          } else {
            continue
          }
        } else {
          if (!routeUnit.isIdenticalPrev && viewConfig && viewConfig.controller) {
            try {
              const controllerResult = await viewConfig.controller(routeUnit, this.env)

              if (controllerResult) {
                if (controllerResult.goNext) {
                  continue
                }
                if (controllerResult.redirect) {
                  result.redirectTo = enhanceWithParams(
                    controllerResult.redirect.to,
                    controllerResult.redirect.withQueryParams ? location.search : ''
                  )
                  result.httpStatus = controllerResult.httpStatus
                  break
                }
                if (controllerResult.httpStatus) {
                  result.httpStatus = controllerResult.httpStatus
                }
                if (controllerResult.error) {
                  result.error = routeUnit.error = controllerResult.error
                  this.errorHandler(result.error)
                  result.httpStatus = controllerResult.error.status
                }
                if (controllerResult.scroll !== undefined) {
                  result.scroll = controllerResult.scroll
                }
              }
            } catch (e) {
              error = new RouteError(e)
              this.errorHandler(error)
              result.error = routeUnit.error = error
              result.httpStatus = error.status
              result.scroll = ScrollBehavior.Top
            }
            result.stateChain.push({
              path: route.path,
              displayName: route.viewConfig && route.viewConfig.displayName || undefined,
              error: result.error
            })
            if (result.error) {
              break
            }
          } else {
            result.stateChain.push({
              path: route.path,
              displayName: route.viewConfig && route.viewConfig.displayName || undefined
            })
          }
        }

        if (!rootRouteUnit) {
          rootRouteUnit = routeUnit
        }
        parentRouteUnit = routeUnit

        // Загружаем компоненты для роута
        if (viewConfig) {
          if (!viewConfig.Component && viewConfig.loadComponent) {
            viewConfig.Component = await viewConfig.loadComponent()
          }
          if (!viewConfig.ErrorComponent && viewConfig.loadErrorComponent) {
            viewConfig.ErrorComponent = await viewConfig.loadErrorComponent()
          }
          if (!viewConfig.ChildErrorComponent && viewConfig.loadChildErrorComponent) {
            viewConfig.ChildErrorComponent = await viewConfig.loadChildErrorComponent()
          }
        }

        if (relativeRouteUnit) {
          relativeRouteUnit = relativeRouteUnit.child || null
        }

        if (route.routes) {
          prefix = routePath[routePath.length - 1] === '/' ? routePath : (routePath + '/')
          queue = route.routes.slice()
        } else {
          break
        }
      }
    } while (queue.length)

    if (result.redirectTo === undefined) {
      this.location = location
      this.rootRouteUnit = rootRouteUnit
      this.updateComponents()
    }

    return result
  }

  /**
   * Рендерим роуты, в соответствии с текущим url
   */
  renderRoutes (): JSX.Element | null {
    return <RouteRoot manager={this} />
  }

  /**
   * Обновить компоненты
   */
  private updateComponents () {
    this.emitter.emit(RouteManagerEvents.ControllersUpdated)
  }
}

const routeContextTypes = {
  [Context.Router]: PropTypes.shape({
    manager: PropTypes.object,
    getRouteUnit: PropTypes.func
  })
}

class RouteRoot<Env> extends Component<{manager: RouteManager<Env>}> {
  static childContextTypes = routeContextTypes

  getChildContext () {
    return {
      [Context.Router]: {
        manager: this.props.manager,
        getRouteUnit: () => this.props.manager.rootRouteUnit
      }
    }
  }

  render () {
    const {rootRouteUnit} = this.props.manager

    return rootRouteUnit
      ? rootRouteUnit.render()
      : null
  }
}

export class RouteChildren<Env> extends Component {
  static childContextTypes = routeContextTypes
  static contextTypes = routeContextTypes

  get manager (): RouteManager<Env> {
    return this.context[Context.Router].manager
  }

  get routeUnit (): RouteUnit<Env> {
    return this.context[Context.Router].getRouteUnit()
  }

  private pendingUpdate = false

  componentDidMount () {
    this.manager.emitter.on(RouteManagerEvents.ControllersUpdated, this.updateComponent)
  }

  componentDidUpdate () {
    if (this.pendingUpdate && this.routeUnit.isRoot()) {
      this.manager.emitter.emit(RouteManagerEvents.ComponentsUpdated)
    }
    this.pendingUpdate = false
  }

  componentWillUnmount () {
    this.manager.emitter.removeListener(RouteManagerEvents.ControllersUpdated, this.updateComponent)
  }

  getChildContext () {
    return {
      [Context.Router]: {
        manager: this.manager,
        getRouteUnit: () => this.routeUnit.child
      }
    }
  }

  updateComponent = () => {
    if (!this.pendingUpdate) {
      this.pendingUpdate = true
      this.forceUpdate()
    }
  }

  render () {
    const {child} = this.routeUnit

    return child
      ? child.render()
      : null
  }
}

export class RouteUnit<Env, Params extends {} = IParams> {
  /**
   * Текущий шейп роута, для которого вызывается контроллер
   */
  routeShape: IRouteShape<Env>
  /**
   * Текущий матч
   */
  match: IMatch
  /**
   * Локейшн
   */
  location: ILocation
  /**
   * Параметры
   */
  params: Params
  /**
   * Дочерний роут
   */
  child?: RouteUnit<Env>
  /**
   * Родительский роут
   */
  parent?: RouteUnit<Env>
  /**
   * Роут, который заменит текущий роут
   */
  next?: RouteUnit<Env>
  /**
   * Роут-менеджер
   */
  manager: RouteManager<Env>
  /**
   * Предыдущий роут
   */
  prev?: RouteUnit<Env>
  /**
   * Emitter
   */
  emitter: EventEmitter
  /**
   * Время создания
   */
  createdAt: Date
  /**
   * Ошибка во время загрузки данных роута
   */
  error?: RouteError

  constructor (routeShape: IRouteShape<Env>, match: IMatch, location: ILocation, manager: RouteManager<Env>, parent?: RouteUnit<Env>) {
    this.emitter = new EventEmitter()
    this.routeShape = routeShape
    this.match = match
    this.location = location
    this.manager = manager
    this.parent = parent
    this.params = this.prepareParams() as Params
    this.createdAt = new Date()
  }

  get url (): string {
    return this.location.pathname + (this.location.search === '?' ? '' : this.location.search)
  }

  get history (): History {
    return this.manager.history
  }

  isRoot (): boolean {
    return this === this.manager.rootRouteUnit
  }

  /**
   * Является ли следующий роут идентичным текущему
   */
  get isIdenticalNext (): boolean {
    if (!this.next) {
      return false
    }
    return this.isIdenticalNextComponent
      && isEqual(this.params, this.next.params)
      && this.error === this.next.error
  }

  /**
   * Является ли компонент следующего роута идентичным текущему
   */
  get isIdenticalNextComponent (): boolean {
    return Boolean(
      this.next && this.next.routeShape.viewConfig && this.routeShape.viewConfig &&
      this.next.routeShape.viewConfig.Component === this.routeShape.viewConfig.Component
    )
  }

  /**
   * Является ли роут идентичным следующему
   */
  get isIdenticalPrev (): boolean {
    if (!this.prev) {
      return false
    }
    return this.isIdenticalPrevComponent
      && isEqual(this.params, this.prev.params)
      && this.error === this.prev.error
  }

  /**
   * Является ли компонент предыдущего роута идентичным текущему
   */
  get isIdenticalPrevComponent () {
    return Boolean(
      this.prev && this.prev.routeShape.viewConfig && this.routeShape.viewConfig &&
      this.prev.routeShape.viewConfig.Component === this.routeShape.viewConfig.Component
    )
  }

  componentDidMount () {
    if (this.routeShape.redirectTo) {
      this.history.replace(this.routeShape.redirectTo)
    }
  }

  /**
   * Отрисовываем контент
   */
  render () {
    if (this.error) {
      let ErrorComponent = this.routeShape.viewConfig!.ErrorComponent

      if (!ErrorComponent && !this.isRoot()) {
        ErrorComponent = this.parent!.routeShape.viewConfig!.ErrorComponent
      }
      if (!ErrorComponent) {
        ErrorComponent = this.manager.DefaultErrorComponent
      }
      return <ErrorComponent error={this.error} routeUnit={this} />
    }
    if (this.routeShape.redirectTo) {
      return null
    }
    const Content = this.routeShape.viewConfig!.Component!

    return <Content />
  }

  private prepareParams () {
    const queryString = this.routeShape.path.split('?')[1]
    const queryParamsKeys = queryString ? queryString.trim().split('&') : []
    const filteredQueryParams = humps.camelizeKeys(pick(this.location.params, queryParamsKeys))

    return merge({}, this.routeShape.params, filteredQueryParams, this.match.params)
  }
}

export type RouteProps<Env = any, Params = {}> = {
  route: RouteUnit<Env, Params>
  routeManager: RouteManager<Env>
}

export type WithHistoryProps = {
  history: History
}

export type WithLegacyRoutesConfigProps = {
  legacyRoutes?: OriginalRouteProps[]
}

/**
 * HOC который достает из контекста ближайший роут
 */
export function withRoute<P extends {}, Env = any> (OriginalComponent: ComponentType<P & RouteProps<Env>>): ComponentClass<P> {
  class WrappedComponent extends Component<P> {
    static displayName = wrapDisplayName(OriginalComponent, 'withRoute')
    static contextTypes = routeContextTypes
    render () {
      const context = this.context[Context.Router]

      return <OriginalComponent {...this.props} route={context.getRouteUnit()} routeManager={context.manager}/>
    }
  }
  hoistNonReactStatics<P, RouteProps<Env>>(WrappedComponent, OriginalComponent)
  return WrappedComponent
}

export const withHistory = hoistStatics(compose(
  getContext({router: PropTypes.object}),
  mapProps(({router, ...other}: {router: any}) => ({...other, history: router.history}))
)) as <P = {}>(C: ComponentType<P & WithHistoryProps>) => ComponentType<P>

export function addQueryParams (u: string, obj: object): string {
  const {pathname = '', search = ''} = url.parse(u)

  return pathname + '?' + qs.stringify({...qs.parse(search), ...obj})
}

export function removeQueryParams (u: string, keys: string[]): string {
  const {pathname = '', search = ''} = url.parse(u)

  return pathname + '?' + qs.stringify(omit(qs.parse(search), keys))
}

export const locationDescriptorToString = (to: History.LocationDescriptor) => (
  typeof to === 'string' ? to : to.pathname + (to.search || '') + (to.hash || '')
)

export function enhanceLocationToWithBaseURL (to: LocationDescriptor, baseURL: string) {
  if (typeof to !== 'string') {
    if (to.pathname !== undefined && to.pathname.indexOf(baseURL) !== 0) {
      to = {...to}
      to.pathname = path.join(baseURL, to.pathname!)
    }
  } else if (to.indexOf(baseURL) !== 0) {
    to = path.join(baseURL, to)
  }
  return to
}

export function enhanceWithParams (u: string, params: object | string = {}): string {
  let extraParams

  if (typeof params === 'string') {
    extraParams = qs.parse(params)
  } else {
    extraParams = params
  }
  const [path, search] = u.split('?')
  const newSearch = qs.stringify({...extraParams, ...qs.parse(search)})

  return path + (newSearch ? ('?' + newSearch) : '')
}

export const Link = withRoute<OriginalLinkProps>(({routeManager, to, route, ...props}) => {
  to = enhanceLocationToWithBaseURL(to, routeManager.baseURL)
  return <OriginalLink to={to} {...props} />
})
